import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  min-height: 300px;
  flex-direction: column;
  justify-content: center;

  button {
    background-color: red;
  }

  button {
    padding: 6px 16px !important;
  }
`;

export const MapContent = styled.div`
  background-color: #d8d8d8;
  height: 206px;
  margin-top: 2px;

  .mapToolbarContaineer {
    width: unset;
  }
`;

export const MapInfos = styled.div`
  padding: 1rem;

  img {
    width: 18px;
  }

  .info-equipment,
  .info-sub-title {
    margin-left: 30px;
  }
  .info-title {
    font-weight: 700;
    font-size: 14px;
  }
  .info-sub-title {
    font-size: 12px;
    color: var(--grey-350);
  }
  .info-equipment {
    font-size: 12px;
    margin-top: 10px;
  }
`;

export const RouteTabs = styled.div`
  border-radius: 2px;
  border: 1px solid var(--grey-300);
  margin: 0 1rem;
`;

export const PanelDetails = styled.div`
  box-shadow: 0px 2px 1px rgb(0 0 0 / 6%);
  padding: 8px;

  a {
    cursor: pointer;
  }

  p {
    color: var(--grey-400);

    strong {
      color: var(--grey-500);
      font-weight: 600;
    }
  }
`;

export const PanelTable = styled.div`
  padding: 8px;

  a {
    cursor: pointer;
  }

  table {
    width: 100%;
  }

  th {
    font-size: 10px;
    text-transform: uppercase;
    color: var(--grey-400);
  }

  th,
  td {
    padding: 4px;
    text-align: left;
  }
`;

export const CoordinateDetails = styled.div`
  padding: 8px;

  p {
    color: var(--grey-400);

    strong {
      color: var(--grey-500);
      font-weight: 600;
    }
  }
`;

export const TextLink = styled.span`
  color: var(--secondary-200);
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
